import { classNames } from 'primereact/utils';
import { TRANSITIONS } from './sharedTailwindThemesFunc';

export const MenuTailwindThemes = {
  // Visual parity with the themed Dropdown panel (`themedDropdownPt`): gray-110 border,
  // gray-50 hover wash on rows, 14/20 font.
  menu: {
    root: 'py-1 bg-white text-fletchers-black-900 border border-fletchers-gray-110 rounded-md w-48',
    menu: {
      className: classNames('m-0 p-0 list-none', 'outline-none'),
    },
    content: () => ({
      className: classNames(
        'text-[0.875rem]/5 font-[400] text-fletchers-black-900 transition-shadow duration-200 rounded-none',
        'hover:bg-fletchers-green-50',
      ),
    }),
    action: {
      className: classNames(
        'text-fletchers-black-900 py-2 px-4 select-none',
        'cursor-pointer flex items-center no-underline overflow-hidden relative',
      ),
    },
    menuitem: {
      className: classNames('hover:bg-fletchers-green-50'),
    },
    icon: 'text-fletchers-black-900 mr-2',
    submenuheader: {
      className: classNames('m-0 p-3 text-fletchers-black-900 bg-white font-bold rounded-tl-none rounded-tr-none'),
    },
    separator: 'border-t border-fletchers-gray-110 my-1',
    transition: TRANSITIONS.overlay,
  },
};
